import { Component, Input, OnInit } from '@angular/core';
import { TableRow } from './table-card.types';
import { checkInputsForText } from '../../design-system.helper';

/**
 * Renders a card that displays a header and a small table
 *
 * When the view is small enough, this responds by displaying the header above the table, otherwise with the header next to the table
 *
 * Note this is not meant to be a full table, and is therefore explicitly a _text_ table, not an actual datagrid
 */
@Component({
  selector: 'table-card',
  templateUrl: './table-card.component.html',
  styleUrls: ['./table-card.component.scss'],
})
export class TableCardComponent implements OnInit {
  @Input() headerText?: string;
  @Input() tableData: TableRow[];

  ngOnInit() {
    const [tableData] = checkInputsForText([this.tableData]);

    this.tableData = tableData as TableRow[];
  }
}
